import React, { Component } from 'react';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import { getMediaPath, createGalleryItem, findCategoryById } from '../../../../app/functions';
import ImageBanner from './image-banner';
import VideoBanner from './video-banner';
import sliderArrowIcon from '../../../../assets/icons/top-slider-arrow-new.svg';
import './top-slider.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Analytics from "app/analytics";
import { getBenefitById } from "../../../../redux/actions";


class TopSlider extends Component {
    shouldComponentUpdate(nextProps) {
        return (
            this.props.data !== nextProps.data
            || this.props.deviceState !== nextProps.deviceState
        );
    }

    componentDidMount() {
        const { data: raw = [] } = this.props;
        const data = [...raw];
        

        let itemsForLog = [];
        Array.from(data).forEach((bannerData, index) => {
            let category = this.props.categoriesMap?.[String(bannerData?.Link?.Link?.parameters?.id)] || null;
            const item = createGalleryItem({ link: bannerData?.Link?.Link, index, category: category , benefit: bannerData?.benefit});
            itemsForLog.push(item);
        });

        Analytics.logBannersSlidersHomePage(itemsForLog);
    }

    handleBannerClick = (bannerData, index) => {
        const linkData = bannerData['Link']['Link'];
        
        let category = this.props.categoriesMap?.[String(linkData.parameters.id)] || null;

        const item = createGalleryItem({ 
            link:linkData,
            index,
            category: category,
            benefit: bannerData.benefit
            })
        
        Analytics.logSelectPromotionTopGallery(item)
        Analytics.logHomepageTopSliderPress(bannerData?.['id'], bannerData?.['title'])
    }

    render() {
        const { data: raw = [] } = this.props;
        const data = [...raw];
        if (data.length > 0) {
            data.push(data.shift());
        }

        const isMobile = (this.props.deviceState === 'mobile');
        const intervalDuration = this.props.intervalDuration * 1000;

        const bannersList = [];

        Array.from(data).forEach((bannerData, index) => {
            if (!bannerData) return;

            const bannerType = Number(bannerData['banner_type']);

            switch (bannerType) {
                // Video banner
                case 1:
                    bannersList.push(
                        <VideoBanner key={bannerData['id']} data={bannerData} />
                    );
                    break;

                // Image banner (default)
                case 0:
                default:
                    bannersList.push(
                        <ImageBanner key={bannerData['id']} data={bannerData} onBannerClick={() => this.handleBannerClick(bannerData, index)} />
                    );
            }
        });

        const sliderSettings = {
            rtl: true,
            dots: true,
            arrows: !isMobile,
            adaptiveHeight: false,
            draggable: isMobile,
            initialSlide: 0,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: intervalDuration,
            pauseOnHover: true,
            nextArrow: (<SliderArrow customClass="slider-next" source={"topSlider"} />),
            prevArrow: (<SliderArrow customClass="slider-prev" source={"topSlider"} />),
        };

        return (
            <section className="top-slider">
                {bannersList.length > 0 && (
                    <Slider {...sliderSettings}>
                        {bannersList}
                    </Slider>
                )}
            </section>
        );
    }
}

const SliderArrow = ({ customClass, onClick, source }) => {

    //changed to be fit for rtl slide
    const handleClick = (event) => {
        if (customClass.includes('slider-next')) {
            Analytics.logGalleryCarouselScrollBack();
        } else if (customClass.includes('slider-prev')) {
            Analytics.logGalleryCarouselScrollForward();
        }
        if (onClick) {
            onClick(event);
        }
    };

    return (
        <div className={customClass} onClick={handleClick}>
            <img src={getMediaPath(sliderArrowIcon)} alt="Arrow Icon" />
        </div>
    );
};

const mapStateToProps = (store) => {
    return {
        intervalDuration: store.config.homePageBannersInterval,
        deviceState: store.state.deviceState,
        categoriesMap: store.config.categoriesMap,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getBenefitById: (payload) => dispatch(getBenefitById(payload)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(TopSlider);
